import { render, staticRenderFns } from "./BosHero.vue?vue&type=template&id=bd665808&scoped=true"
import script from "./BosHero.vue?vue&type=script&lang=js"
export * from "./BosHero.vue?vue&type=script&lang=js"
import style0 from "./BosHero.vue?vue&type=style&index=0&id=bd665808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd665808",
  null
  
)

export default component.exports